/**
 * Login/index.js — Email/password login screen using Firebase Authentication.
 * Shown to unauthenticated users. On successful login, Firebase's onAuthStateChanged
 * listener in App.js picks up the new auth state and swaps to the authenticated router.
 */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
// -----------------------------------------------------
import logo from "Media/accent3.png";
// -----------------------------------------------------
// -----------------------------------------------------
const Login = () => {
  const [data, setData] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (evt) => {
    const { id, value } = evt.target;
    setData({ ...data, [id]: value });
  };

  const login = () => {
    setLoading(true);
    const auth = getAuth();
    const { email, password } = data;
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        const errorCode = error.code;
        // error.message available if needed
        switch (errorCode) {
          case "auth/user-not-found":
            setError("User not found.");
            break;
          default:
            setError("An error has occurred");
        }
      });
  };

  return (
    <div className="login-wrapper">

      <div className="box" style = {{padding: 75}}>
        <img src={logo} width="230" height="56" alt="Logo" />
        <br />
        <hr />
        <div className="field">
          <p className="control has-icons-left has-icons-right">
            <input
              className="input"
              type="email"
              placeholder="Email"
              value={data.email}
              id="email"
              onChange={onChange}
              autoFocus={true}
            />
            <span className="icon is-small is-left">
              <i className="fa-duotone fa-envelope"></i>
            </span>
          </p>
        </div>
        <div className="field">
          <p className="control has-icons-left">
            <input
              className="input"
              type="password"
              placeholder="Password"
              value={data.password}
              id="password"
              onChange={onChange}
            />
            <span className="icon is-small is-left">
              <i className="fa-duotone fa-lock"></i>
            </span>
          </p>
        </div>
        <br />
        <div className="buttons is-right">
          <button
            className={`button is-small  is-pulled-righ ${
              loading ? "is-loading" : ""
            }`}
            disabled={error !== null}
            onClick={login}
          >
            <span>Login</span>
            <span className="icon is-small">
              <i className="fa-duotone fa-right-to-bracket"></i>
            </span>
          </button>
        </div>
        {error ? (
          <div className="notification is-warning">
            {error}
            <a
              role="button"
              tabIndex={0}
              onClick={() => {
                setData({ email: "", password: "" });
                setError(null);
              }}
            >
              OK
            </a>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default Login;